/**
 * Description component for the preferences element
 * @param email - The email of the user
 * @param descriptionText - The localized description text
 * @returns The description component
 */
export function Description({ email, descriptionText }: { email: string; descriptionText: string }) {
  return (
    <p className="text-gray-500 text-sm font-normal">
      {descriptionText} <span className="font-medium text-gray-900">{email}</span>
    </p>
  );
}
